var classes = {"seal":"index-module_seal__S-U3F"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
